export default __webpack_public_path__ + "static/untitled-sans-web-regular-80eadace7227f9618ed3a1ee0a71356a.woff";